import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {media} from '../../../../json-to-from/types/menu/media';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import {Media} from './media';
import {MatSlideToggle, MatSlideToggleChange} from '@angular/material/slide-toggle';
import {menuForm} from '../../../../json-to-from/types/menu/menuForm';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { NgTemplateOutlet } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { SelectMediaComponent } from '../../../../select-media/select-media.component';

const NODE_TYPE = 'media';

@Component({
    selector: 'app-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, MatButtonToggleGroup, MatButtonToggle, NgTemplateOutlet, CMSComponent, NextSelectorComponent, ClickatellFormValidationComponent, ActiveFormDirective, MatSlideToggle, SelectMediaComponent]
})
export class MediaComponent extends NodeBuilder implements OnInit {

    mediaForm: UntypedFormGroup = undefined;
    newStep = undefined;

    constructor() {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
    }

    set buildForm(stepData: any) {
        this.mediaForm = Media.toForm(stepData, this.canEdit);
        if (this.mediaForm.get('next').value === newStepValue) {
            this.newStep = 'step' + this.getNextStep();
            this.mediaForm.get('next').setValue(this.newStep);
        }
    }

    get getStepData(): {} {
        const mediaObj: Media = new Media();
        const rawValue = this.mediaForm.getRawValue();
        mediaObj.setMenu(rawValue);
        const nodeData = mediaObj.nodeData;

        if (!rawValue.endSession || rawValue.mediaDirection === 'inbound') {
            nodeData['next'] = rawValue.next;
        }

        return nodeData;
    }

    get isNodeValid(): boolean {
        this.mediaForm.markAllAsTouched();
        return this.mediaForm.valid;
    }

    public sessionEndToggle(checked): void {
        this.mediaForm.get('endSession').setValue(checked);

        if (this.mediaForm.get('next').value === undefined) {
            if (this.newStep !== undefined) {
                this.mediaForm.get('next').setValue(this.newStep);
            } else {
                this.newStep = 'step' + this.getNextStep();
                this.mediaForm.get('next').setValue(this.newStep);
            }
        }
    }

    public directionChanged(event: MatButtonToggleGroup): void {
        this.mediaForm.get('mediaDirection').setValue(event.value);
    }

    public sourceChanged(event: MatButtonToggleGroup): void {
        this.mediaForm.get('varType').setValue(event.value);
    }

    setImage(event, form) {
        form.get('varName').setValue(event);
    }
}
